module.exports = __webpack_public_path__ + "img/picture_kmskcspvip01.8353c22b.png";